import { MapPin, Check } from "lucide-react";
import { ZONE, IMG } from "@/data/content";
import { Reveal } from "@/lib/motion";
import RevealImage from "@/components/RevealImage";

export default function Zone() {
    return (
        <section className="py-24 md:py-32 bg-mist" data-testid="zone-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    <div>
                        <Reveal><span className="uppercase text-xs tracking-[0.2em] font-bold text-brand-red font-body">{ZONE.kicker}</span></Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-navy mt-4 mb-6 font-display">
                                {ZONE.title[0]}<br />{ZONE.title[1]}
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}><div className="h-px w-16 bg-brand-red mb-8" /></Reveal>
                        <Reveal delay={0.12}><p className="text-base leading-relaxed text-slate-500 mb-8 font-body">{ZONE.intro}</p></Reveal>

                        <Reveal delay={0.16} className="flex items-start gap-3 mb-8">
                            <MapPin className="w-5 h-5 text-brand-red mt-0.5" />
                            <div>
                                <p className="text-xs uppercase tracking-wider text-slate-400 font-body mb-1">{ZONE.addressTitle}</p>
                                {ZONE.addressLines.map((l) => (
                                    <p key={l} className="text-sm font-semibold text-navy font-body">{l}</p>
                                ))}
                            </div>
                        </Reveal>

                        <div className="grid grid-cols-2 gap-3">
                            {ZONE.cities.map((c, i) => (
                                <Reveal key={c} delay={0.2 + i * 0.04} className="flex items-center gap-2 text-sm text-slate-600 font-body">
                                    <Check className="w-4 h-4 text-electric flex-shrink-0" /> {c}
                                </Reveal>
                            ))}
                        </div>
                    </div>

                    <Reveal y={0} className="relative">
                        <RevealImage src={IMG.strasbourg} alt="Strasbourg, Alsace" className="h-[500px]" aspect="" testid="zone-image" />
                        <div className="absolute inset-0 bg-gradient-to-t from-navy/50 to-transparent pointer-events-none" />
                        <div className="absolute bottom-6 left-6 right-6">
                            <div className="bg-white/95 backdrop-blur-sm p-4">
                                <p className="text-sm font-semibold text-navy font-display">{ZONE.caption}</p>
                                <p className="text-xs text-slate-500 font-body">{ZONE.subcaption}</p>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
